export default __webpack_public_path__ + "static/media/quadruple-portrait.f8b9aea3.svg";